import { makeStyles, Theme } from '@material-ui/core/styles';

interface StyleProps {
  bgColor: string;
}

export const useStyles = makeStyles<Theme, StyleProps>((theme: Theme) => ({
  root: {
    width: '100%',
  },
  tableContainer: {
    boxShadow: 'none',
    border: 'none',
    borderRadius: 0,
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
  },
  headerCell: {
    backgroundColor: (props) => props.bgColor,
    color: '#FFFFFF',
    fontFamily: 'Poppins',
    fontSize: '14px',
    fontWeight: 600,
    textTransform: 'uppercase',
    padding: '20px 16px',
    borderBottom: 'none',
    position: 'sticky',
    top: 0,
    zIndex: 10,
    '&:first-child': {
      paddingLeft: '24px',
    },
    '&:last-child': {
      paddingRight: '24px',
    },
  },
  bodyRow: {
    '&:hover': {
      backgroundColor: '#F7F7FB',
    },
    '& td': {
      borderBottom: '1px solid #E4E4F2',
    },
  },
  bodyCell: {
    fontFamily: 'Poppins',
    fontSize: '14px',
    color: '#0E1247',
    padding: '16px',
    verticalAlign: 'top',
    '&:first-child': {
      paddingLeft: '24px',
    },
    '&:last-child': {
      paddingRight: '24px',
    },
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '300px',
  },
  emptyContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '300px',
    fontFamily: 'Poppins',
    fontSize: '16px',
    color: '#6B7280',
  },
  paginationContainer: {
    marginTop: '20px',
  },
}));

